<template>
  <v-app id="inspire">

    <!-- <v-container grid-list-md text-xs-center>
      <v-layout row wrap>
          <v-progress-linear :indeterminate="true" v-show="loadingOk === true"></v-progress-linear>
        <v-flex xs12>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-flex xs12 sm12>
              <v-text-field
                class="username"
                label="E-Mail/Usuário"
                v-model="username"
                :counter="40"
                :rules="[v => !!v || 'E-mail obrigatório!!']" required
                prepend-icon="email"
              ></v-text-field>
            </v-flex>
            <div class="buttons">
              <router-link to="/schedule">
                <v-btn @click="clear">Voltar</v-btn>
              </router-link>
              <v-btn
                color = 'primary'
                @click="searchEmail"
                :disabled="!valid"
              >
                Avançar
              </v-btn>
            </div>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container> -->


    <!-- <v-card >
      <v-toolbar :color="this.getTheme.color" dark>
        <v-toolbar-side-icon></v-toolbar-side-icon>
        <v-toolbar-title>Selecionar Agenda</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon>search</v-icon>
        </v-btn>
        <v-btn icon @click="selectedAll()">
          <v-icon>check_box</v-icon>
        </v-btn>
      </v-toolbar>
      <v-list two-line>
        <template v-for="(item, index) in newRegisters">
          <v-list-tile
            :key="item.title"
            avatar
            ripple
            @click="toggle(index)"
          >
            <v-list-tile-content>
              <v-list-tile-title>Clinica/Hosp.: {{ item.clientName }}</v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">Nome: {{ item.name }}</v-list-tile-sub-title>
              <v-list-tile-sub-title>CRM: {{ item.crm }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider
            v-if="index + 1 < newRegisters.length"
            :key="index"
          ></v-divider>
        </template>
      </v-list>
    </v-card> -->



    <v-content>
      <v-container fluid fill-height>
        <v-layout >
          <v-flex xs12 sm6 offset-sm3>
            <p class="display-1 text-no-wrap text-md-center font-weight-thin font-italic"></p>
            <v-card>
              <v-card >
                <v-toolbar :color="this.getTheme.color" dark>
                  <v-toolbar-side-icon></v-toolbar-side-icon>
                  <v-toolbar-title>Selecionar Agenda</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-menu bottom left>
                    <v-btn icon slot="activator">
                      <v-icon>more_vert</v-icon>
                      <!-- <v-avatar size="32px" tile>
                        <img src="https://storage.googleapis.com/spitzer-io/img/Logo%20Spitzer%20icone.png" alt="Sptizer.io">
                      </v-avatar> -->
                    </v-btn>
                    <v-list>
                      <v-list-tile to="/update-schedule">
                        <v-list-tile-action>
                          <v-icon>update</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>Atualizar agendas</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-toolbar>
                <v-list two-line>
                  <div :key="index" v-for="(item, index) in auth.customers">
                    <v-list-tile
                      avatar
                      ripple
                      @click="toggle(index, item.myClinic)"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>Clinica/Hosp.: {{ item.myClinic.customerName }}</v-list-tile-title>
                        <v-list-tile-sub-title class="text--primary">Nome: {{ item.myClinic.name }}</v-list-tile-sub-title>
                        <v-list-tile-sub-title><span>CRM/ID:</span> {{ item.myClinic.crm }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <!-- <v-list-tile-action-text><v-checkbox v-model="item.myClinic.action" @click="toggle"></v-checkbox></v-list-tile-action-text> -->
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider
                      v-if="index + 1 < auth.customers.length"
                    ></v-divider>
                  </div>
                </v-list>
              </v-card>

              <v-card-actions>
                <router-link to="/schedule">
                  <v-btn flat color="orange" >Cancelar</v-btn>
                </router-link>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  export default {
    computed: {
      ...mapGetters({
        customer: 'customer',
        auth: 'auth'
      }),
      ...mapGetters('app', ['getTheme', 'getDevice']),
      ...mapGetters('auth', ['getRegisterUser', 'getSearchUser'])
    },
    data () {
      return {
        newRegisters: [],
        items: [],
        valid: false,
        loadingOk: false,
        loadingButton: false,
        loader: null,
        e1: true,
        p1: true,
        custom: true,
        username: null,
        checkbox: false,
        item: {
          action: false
        }
      }
    },
    mounted () {
      if (process.env.NODE_ENV !== 'production') {
        this.username = 'andreza_82@hotmail.com'
      }
    },
    methods: {
      ...mapActions('auth', ['setChangeSchedule', 'setSearchEmailNew']),
      searchEmail () {
        this.$validator.validateAll()
        if (this.$refs.form.validate()) {
          this.loader = true
          this.loadingOk = true
          this.setSearchEmailNew(this.username).then(() => {
            this.getSearchUser.map((item) => {
              this.newRegisters.push({
                crm: item.crm,
                customer: item.customerId,
                client: item.client,
                clientName: item.clientName,
                state: item.state || 'PR',
                code: item.client,
                name: item.clientName,
                codeCustomer: item.client,
                customerName: item.clientName
              })
            })
            console.log('this.newRegisters', this.newRegisters)
            this.loadingOk = false
          }).catch((err) => {
            console.error(err)
          })
        }
      },
      clear () {
        this.$refs.form.reset()
      },
      toggle (index, item) {
        const payload = {
          code: item.code,
          codeCustomer: item.code,
          crm: item.crm,
          customer: item.customer,
          customerName: item.customerName,
          id: item._id,
          name: item.name,
          state: item.state
        }
        this.setChangeSchedule(payload).then(() => this.$router.push('/schedule'))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/schedule/change.vue